import { useCallback, useState } from 'react';
import { useMutation } from '@apollo/client';
import { ADMIN_INPUT_HMA, ADMIN_INPUT_HRV } from '../../services/graphql/mutations/admin';
import { useSelector } from 'react-redux';
import { LIST_ANALYSES_VIEW } from '../../services/graphql/queries/admin';

interface CreateHrvInput {
  professionalId: string;
  clientMutationId?: string;
  hrvData: any;
}

export function useCreateHRV() {
  const token = useSelector((state: any) => state.auth.token);
  const [adminCreateHRV, { loading }] = useMutation(ADMIN_INPUT_HRV, {
    refetchQueries: [
      { query: LIST_ANALYSES_VIEW, variables: { viewType: 'hrv', page: 1, perPage: 15 } }
    ],
    awaitRefetchQueries: true,
  });
  const [result, setResult] = useState<any>([]);

  const createData = useCallback(async (values: CreateHrvInput) => {
    try {
      const { data } = await adminCreateHRV({
        variables: {
          input: {
            ...values
          },
        },
        context: {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      });
      setResult(data);
      return data;
    } catch (error) {
      console.error('Error in adminCreateHRV: ', error);
      throw error;
    }
  }, [adminCreateHRV]);

  return {
    data: result,
    create: createData,
    loading
  };
}
